import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { onReread } from "@/lib/reread";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = ["me-follow-ups"];
const tz = () => Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

export function useMyFollowUps(limit = 5) {
  const { user } = useAuth();
  const qc = useQueryClient();
  useEffect(() => onReread(() => qc.invalidateQueries({ queryKey: KEY })), [qc]);
  return useQuery({
    queryKey: [...KEY, user?.workspace_id ?? null, limit],
    queryFn: () => api.get("/me/follow-ups", { params: { limit, tz: tz() } }).then((r) => r.data),
    staleTime: 0,
    enabled: !!user,
  });
}

export function useInvalidateMyFollowUps() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: KEY });
}
